export enum StartMode {
  SEARCH = 'search',
  NODE = 'node',
  QUERY= 'query'
}
